module.exports = __webpack_public_path__ + "static/media/dept-logo.63264c69.png";